const translations = {
  en: {
    appName: 'RESCUEID',
    home: {
      subtitle: 'Your emergency medical profile, accessible instantly when it matters most.',
      getStarted: 'Get Started',
      login: 'Login',
      darkMode: 'Dark Mode',
      lightMode: 'Light Mode'
    },
    login: {
      title: 'Welcome back',
      email: 'Email',
      password: 'Password',
      submit: 'Login',
      loading: 'Logging in...',
      forgotPassword: 'Forgot password?',
      noAccount: "Don't have an account?",
      register: 'Register',
      errors: {
        email: 'Email is required',
        invalidEmail: 'Invalid email address',
        password: 'Password is required'
      }
    },
    register: {
      title: 'Create your account',
      fullName: 'Full Name',
      dateOfBirth: 'Date of Birth',
      gender: 'Select Gender',
      male: 'Male',
      female: 'Female',
      other: 'Other',
      bloodGroup: 'Select Blood Group',
      email: 'Email',
      password: 'Password',
      submit: 'Create Account',
      loading: 'Creating account...',
      hasAccount: 'Already have an account?',
      login: 'Login',
      errors: {
        fullName: 'Full name is required',
        dateOfBirth: 'Date of birth is required',
        gender: 'Please select a gender',
        bloodGroup: 'Please select a blood group',
        email: 'Email is required',
        invalidEmail: 'Invalid email address',
        password: 'Password is required',
        passwordLength: 'Password must be at least 6 characters'
      }
    },
    dashboard: {
      darkMode: 'Dark Mode',
      lightMode: 'Light Mode',
      logout: 'Logout',
      emergencyLink: 'Your Emergency Access Link',
      emergencySubtitle: 'Share this link or QR code with your wallet or phone case. Emergency responders can access your info without logging in.',
      uploadPhoto: 'Upload Photo',
      uploading: 'Uploading...',
      copy: 'Copy',
      scanQR: 'Scan to access emergency profile',
      downloadQR: 'Download QR Code',
      personalDetails: 'Personal Details',
      medicalDetails: 'Medical Details',
      emergencyContacts: 'Emergency Contacts',
      fullName: 'Full Name',
      allergies: 'Allergies (e.g. Peanuts, Penicillin)',
      medications: 'Current Medications (e.g. Metformin 500mg)',
      medicalConditions: 'Medical Conditions (e.g. Type 2 Diabetes)',
      contactName: 'Full Name',
      relationship: 'Relationship (e.g. Father, Spouse)',
      phone: 'Phone Number',
      addContact: '+ Add Another Contact',
      removeContact: 'Remove',
      contact: 'Contact',
      saveProfile: 'Save Profile',
      saving: 'Saving...',
      saveSuccess: 'Profile updated successfully!',
      saveFail: 'Failed to update profile',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      updatePassword: 'Update Password',
      updating: 'Updating...',
      passwordSuccess: 'Password changed successfully!',
      deleteAccount: 'Delete Account',
      deleteWarning: 'This will permanently delete your account and all your data. This cannot be undone.',
      deleteConfirm: 'Yes, Delete My Account',
      deleting: 'Deleting...',
      printCard: 'Print Emergency Card'
    },
    emergency: {
      badge: 'EMERGENCY ACCESS',
      aiTitle: 'AI Paramedic Summary',
      generating: 'Generating summary...',
      medicalInfo: 'Medical Information',
      allergies: 'Allergies',
      medications: 'Medications',
      conditions: 'Conditions',
      noneReported: 'None reported',
      emergencyContacts: 'Emergency Contacts',
      noContacts: 'No emergency contacts added',
      call: 'Call',
      footer: 'Powered by RescueID — For emergency use only',
      printCard: 'Print Emergency Card'
    }
  },
  hi: {
    appName: 'RESCUEID',
    home: {
      subtitle: 'आपकी आपातकालीन चिकित्सा प्रोफ़ाइल, जरूरत के समय तुरंत उपलब्ध।',
      getStarted: 'शुरू करें',
      login: 'लॉगिन',
      darkMode: 'डार्क मोड',
      lightMode: 'लाइट मोड'
    },
    login: {
      title: 'वापस स्वागत है',
      email: 'ईमेल',
      password: 'पासवर्ड',
      submit: 'लॉगिन',
      loading: 'लॉगिन हो रहा है...',
      forgotPassword: 'पासवर्ड भूल गए?',
      noAccount: 'खाता नहीं है?',
      register: 'रजिस्टर करें',
      errors: {
        email: 'ईमेल आवश्यक है',
        invalidEmail: 'अमान्य ईमेल पता',
        password: 'पासवर्ड आवश्यक है'
      }
    },
    register: {
      title: 'अपना खाता बनाएं',
      fullName: 'पूरा नाम',
      dateOfBirth: 'जन्म तिथि',
      gender: 'लिंग चुनें',
      male: 'पुरुष',
      female: 'महिला',
      other: 'अन्य',
      bloodGroup: 'रक्त समूह चुनें',
      email: 'ईमेल',
      password: 'पासवर्ड',
      submit: 'खाता बनाएं',
      loading: 'खाता बन रहा है...',
      hasAccount: 'पहले से खाता है?',
      login: 'लॉगिन',
      errors: {
        fullName: 'पूरा नाम आवश्यक है',
        dateOfBirth: 'जन्म तिथि आवश्यक है',
        gender: 'कृपया लिंग चुनें',
        bloodGroup: 'कृपया रक्त समूह चुनें',
        email: 'ईमेल आवश्यक है',
        invalidEmail: 'अमान्य ईमेल पता',
        password: 'पासवर्ड आवश्यक है',
        passwordLength: 'पासवर्ड कम से कम 6 अक्षर का होना चाहिए'
      }
    },
    dashboard: {
      darkMode: 'डार्क मोड',
      lightMode: 'लाइट मोड',
      logout: 'लॉगआउट',
      emergencyLink: 'आपका आपातकालीन लिंक',
      emergencySubtitle: 'इस लिंक या QR कोड को अपने वॉलेट में रखें। बिना लॉगिन के उपयोग किया जा सकता है।',
      uploadPhoto: 'फोटो अपलोड करें',
      uploading: 'अपलोड हो रहा है...',
      copy: 'कॉपी करें',
      scanQR: 'आपातकालीन प्रोफ़ाइल देखने के लिए स्कैन करें',
      downloadQR: 'QR कोड डाउनलोड करें',
      personalDetails: 'व्यक्तिगत विवरण',
      medicalDetails: 'चिकित्सा विवरण',
      emergencyContacts: 'आपातकालीन संपर्क',
      fullName: 'पूरा नाम',
      allergies: 'एलर्जी',
      medications: 'दवाइयां',
      medicalConditions: 'चिकित्सा स्थितियां',
      contactName: 'पूरा नाम',
      relationship: 'संबंध',
      phone: 'फोन नंबर',
      addContact: '+ और संपर्क जोड़ें',
      removeContact: 'हटाएं',
      contact: 'संपर्क',
      saveProfile: 'प्रोफ़ाइल सहेजें',
      saving: 'सहेजा जा रहा है...',
      saveSuccess: 'प्रोफ़ाइल सफलतापूर्वक अपडेट हुई!',
      saveFail: 'प्रोफ़ाइल अपडेट विफल',
      changePassword: 'पासवर्ड बदलें',
      currentPassword: 'वर्तमान पासवर्ड',
      newPassword: 'नया पासवर्ड',
      confirmPassword: 'नया पासवर्ड पुष्टि करें',
      updatePassword: 'पासवर्ड अपडेट करें',
      updating: 'अपडेट हो रहा है...',
      passwordSuccess: 'पासवर्ड सफलतापूर्वक बदला गया!',
      deleteAccount: 'खाता हटाएं',
      deleteWarning: 'यह आपका खाता और सभी डेटा स्थायी रूप से हटा देगा।',
      deleteConfirm: 'हां, मेरा खाता हटाएं',
      deleting: 'हटाया जा रहा है...',
      printCard: 'आपातकालीन कार्ड प्रिंट करें'
    },
    emergency: {
      badge: 'आपातकालीन पहुंच',
      aiTitle: 'AI पैरामेडिक सारांश',
      generating: 'सारांश तैयार हो रहा है...',
      medicalInfo: 'चिकित्सा जानकारी',
      allergies: 'एलर्जी',
      medications: 'दवाइयां',
      conditions: 'स्थितियां',
      noneReported: 'कोई नहीं',
      emergencyContacts: 'आपातकालीन संपर्क',
      noContacts: 'कोई संपर्क नहीं',
      call: 'कॉल करें',
      footer: 'RescueID द्वारा संचालित — केवल आपातकाल के लिए',
      printCard: 'आपातकालीन कार्ड प्रिंट करें'
    }
  },
  te: {
    appName: 'RESCUEID',
    home: {
      subtitle: 'మీ అత్యవసర వైద్య ప్రొఫైల్, అవసరమైనప్పుడు వెంటనే అందుబాటులో ఉంటుంది.',
      getStarted: 'ప్రారంభించండి',
      login: 'లాగిన్',
      darkMode: 'డార్క్ మోడ్',
      lightMode: 'లైట్ మోడ్'
    },
    login: {
      title: 'తిరిగి స్వాగతం',
      email: 'ఇమెయిల్',
      password: 'పాస్‌వర్డ్',
      submit: 'లాగిన్',
      loading: 'లాగిన్ అవుతోంది...',
      forgotPassword: 'పాస్‌వర్డ్ మర్చిపోయారా?',
      noAccount: 'ఖాతా లేదా?',
      register: 'నమోదు చేయండి',
      errors: {
        email: 'ఇమెయిల్ అవసరం',
        invalidEmail: 'చెల్లని ఇమెయిల్ చిరునామా',
        password: 'పాస్‌వర్డ్ అవసరం'
      }
    },
    register: {
      title: 'మీ ఖాతాను సృష్టించండి',
      fullName: 'పూర్తి పేరు',
      dateOfBirth: 'పుట్టిన తేదీ',
      gender: 'లింగం ఎంచుకోండి',
      male: 'పురుషుడు',
      female: 'స్త్రీ',
      other: 'ఇతర',
      bloodGroup: 'రక్త సమూహం ఎంచుకోండి',
      email: 'ఇమెయిల్',
      password: 'పాస్‌వర్డ్',
      submit: 'ఖాతా సృష్టించండి',
      loading: 'ఖాతా సృష్టిస్తోంది...',
      hasAccount: 'ఇప్పటికే ఖాతా ఉందా?',
      login: 'లాగిన్',
      errors: {
        fullName: 'పూర్తి పేరు అవసరం',
        dateOfBirth: 'పుట్టిన తేదీ అవసరం',
        gender: 'దయచేసి లింగం ఎంచుకోండి',
        bloodGroup: 'దయచేసి రక్త సమూహం ఎంచుకోండి',
        email: 'ఇమెయిల్ అవసరం',
        invalidEmail: 'చెల్లని ఇమెయిల్ చిరునామా',
        password: 'పాస్‌వర్డ్ అవసరం',
        passwordLength: 'పాస్‌వర్డ్ కనీసం 6 అక్షరాలు ఉండాలి'
      }
    },
    dashboard: {
      darkMode: 'డార్క్ మోడ్',
      lightMode: 'లైట్ మోడ్',
      logout: 'లాగ్అవుట్',
      emergencyLink: 'మీ అత్యవసర యాక్సెస్ లింక్',
      emergencySubtitle: 'ఈ లింక్ లేదా QR కోడ్‌ను మీ వాలెట్‌లో ఉంచండి. లాగిన్ లేకుండా యాక్సెస్ చేయవచ్చు.',
      uploadPhoto: 'ఫోటో అప్‌లోడ్ చేయండి',
      uploading: 'అప్‌లోడ్ అవుతోంది...',
      copy: 'కాపీ చేయండి',
      scanQR: 'అత్యవసర ప్రొఫైల్ చూడటానికి స్కాన్ చేయండి',
      downloadQR: 'QR కోడ్ డౌన్‌లోడ్ చేయండి',
      personalDetails: 'వ్యక్తిగత వివరాలు',
      medicalDetails: 'వైద్య వివరాలు',
      emergencyContacts: 'అత్యవసర సంప్రదింపులు',
      fullName: 'పూర్తి పేరు',
      allergies: 'అలెర్జీలు',
      medications: 'మందులు',
      medicalConditions: 'వైద్య పరిస్థితులు',
      contactName: 'పూర్తి పేరు',
      relationship: 'సంబంధం',
      phone: 'ఫోన్ నంబర్',
      addContact: '+ మరో సంప్రదింపు జోడించండి',
      removeContact: 'తొలగించు',
      contact: 'సంప్రదింపు',
      saveProfile: 'ప్రొఫైల్ సేవ్ చేయండి',
      saving: 'సేవ్ అవుతోంది...',
      saveSuccess: 'ప్రొఫైల్ విజయవంతంగా అప్‌డేట్ అయింది!',
      saveFail: 'ప్రొఫైల్ అప్‌డేట్ విఫలమైంది',
      changePassword: 'పాస్‌వర్డ్ మార్చండి',
      currentPassword: 'ప్రస్తుత పాస్‌వర్డ్',
      newPassword: 'కొత్త పాస్‌వర్డ్',
      confirmPassword: 'కొత్త పాస్‌వర్డ్ నిర్ధారించండి',
      updatePassword: 'పాస్‌వర్డ్ అప్‌డేట్ చేయండి',
      updating: 'అప్‌డేట్ అవుతోంది...',
      passwordSuccess: 'పాస్‌వర్డ్ విజయవంతంగా మార్చబడింది!',
      deleteAccount: 'ఖాతా తొలగించండి',
      deleteWarning: 'ఇది మీ ఖాతా మరియు అన్ని డేటాను శాశ్వతంగా తొలగిస్తుంది.',
      deleteConfirm: 'అవును, నా ఖాతా తొలగించండి',
      deleting: 'తొలగిస్తోంది...',
      printCard: 'అత్యవసర కార్డ్ ప్రింట్ చేయండి'
    },
    emergency: {
      badge: 'అత్యవసర యాక్సెస్',
      aiTitle: 'AI పారామెడిక్ సారాంశం',
      generating: 'సారాంశం తయారవుతోంది...',
      medicalInfo: 'వైద్య సమాచారం',
      allergies: 'అలెర్జీలు',
      medications: 'మందులు',
      conditions: 'పరిస్థితులు',
      noneReported: 'ఏదీ లేదు',
      emergencyContacts: 'అత్యవసర సంప్రదింపులు',
      noContacts: 'సంప్రదింపులు లేవు',
      call: 'కాల్ చేయండి',
      footer: 'RescueID ద్వారా — అత్యవసర వినియోగం కోసం మాత్రమే',
      printCard: 'అత్యవసర కార్డ్ ప్రింట్ చేయండి'
    }
  }
};

export default translations;